import { render, staticRenderFns } from "./WalletExtractBalanceCard.vue?vue&type=template&id=03f454ac&scoped=true"
import script from "./WalletExtractBalanceCard.vue?vue&type=script&lang=js"
export * from "./WalletExtractBalanceCard.vue?vue&type=script&lang=js"
import style0 from "./WalletExtractBalanceCard.vue?vue&type=style&index=0&id=03f454ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f454ac",
  null
  
)

export default component.exports